import React, { useContext, useEffect, useMemo } from 'react';
import { CalloutCard } from '.';
import { TrackingContext } from '../../TrackingContext';
import { useEventsQueryLazyQuery } from '../../generated/graphql';

export const marketplaceCtaContent = {
  photographers: {
    title: 'Need a photographer?',
    description: `Explore beautiful galleries <br />from top-rated wedding pros.`,
    linkText: 'See photographers',
    linkTo: 'https://www.theknot.com/marketplace/wedding-photographers',
    imageSrc: 'https://media-api.xogrp.com/images/80c3348f-e3f2-4fdf-adb4-2609285e8a19',
  },
  venues: {
    title: 'Looking for a venue?',
    description: 'Read reviews and contact<br />top-rated venues in your area.',
    linkText: 'See venues',
    linkTo: 'https://www.theknot.com/marketplace/wedding-reception-venues',
    imageSrc: 'https://media-api.xogrp.com/images/7165377b-757d-4ae4-a25e-ddd7e6d7e402',
  },
};

interface Props {
  refetch?: boolean;
}

export const MarketPlaceCallout: React.FC<Props> = ({ refetch = false }) => {
  const { track } = useContext(TrackingContext);
  const [callEventsQuery, { data: eventsData, loading }] = useEventsQueryLazyQuery();

  // Fetch bookings once on mount and refetch on prop change
  useEffect(() => {
    callEventsQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch]);

  // showPhotographersCTA when we have a venue for the wedding day or reception
  const showPhotographersCTA = useMemo(() => {
    const weddingDay = eventsData?.events?.find(event => event?.type === 'WeddingDay');
    return Boolean(
      weddingDay?.subEvents?.find(subEvent => subEvent?.type === 'Reception')?.location?.name ||
        weddingDay?.location?.name
    );
  }, [eventsData]);

  const cardProps = useMemo(() => {
    return showPhotographersCTA ? marketplaceCtaContent.photographers : marketplaceCtaContent.venues;
  }, [showPhotographersCTA]);

  const handleClick = () => {
    track('WWS Preview Interaction', {
      source: 'home page',
      action: showPhotographersCTA ? 'clicked need a photographer callout' : 'clicked looking for a venue callout',
    });
  };

  if (loading) return null;

  return <CalloutCard onClick={handleClick} data-testid="marketplace-callout" {...cardProps} />;
};
